module.exports = __webpack_public_path__ + "static/media/ico_duda_new.7f14d865.svg";